import 'swiper/css';
import '../scss/main.scss';
import {
  headerDataToggleMobile,
  openDropDown,
  stickyUp,
} from '../components/header';
import { mediaQuery } from '../utils/media-query';
import { stopAutplaySlider } from '../components/hero';
import { lazyLoad } from '../utils/lazy-load';
import { $Q } from '../utils/query-selector';

import '../components/init-slider';
import '../components/mega-menu';
import { newsletterSubmit } from '../components/news-letters';
import { variantOnChange } from '../components/variants-product';
import { addAttributesToLinks } from '../components/links';

openDropDown();
mediaQuery('(max-width: 1100px)', headerDataToggleMobile);
stickyUp('.js-header');
lazyLoad($Q('.js-header'), stopAutplaySlider, {
  rootMargin: '100px',
  threshold: 0,
});

newsletterSubmit();
addAttributesToLinks();
window.addEventListener('pageshow', () => {
  variantOnChange('.variants');
});
